import { OpenFeature } from "@openfeature/web-sdk";

import PerTherapistFeatureProvider from "./PerTherapistFeatureProvider";

OpenFeature.setProvider(new PerTherapistFeatureProvider());
